export default "__VITE_ASSET__xr7PbaEL__"